import React, { useEffect, useState } from "react";
import { FunctionComponent } from "react";
import AppRoomBookings from "./AppRoomBookings";
import { getQueryParams } from "@shared";
import AppVisitors from "./AppVisitors";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import { isNil } from "lodash";
import SelectLocation from "./shared/location/select-location/SelectLocation";

export interface Props {
  isOfficeInitialized: boolean;
}

const App: FunctionComponent<Props> = (props: Props) => {
  const { isOfficeInitialized } = props;
  const [appLoaded, setAppLoaded] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const loadAppropriateApp = () => {
    if (appLoaded) return;
    setAppLoaded(true);

    const currentPath = location.pathname;
    if (currentPath === "/index.html") history.push("/roomBookings");
    if (currentPath === "/visitors") history.push("/visitors/visitorsList");
  };

  return (
    <>
      <Switch>
        <Route exact path="/">
          <h1>Ricoh outlook Add-In App</h1>
        </Route>
        <Route exact path="/visitors/*">
          <AppVisitors isOfficeInitialized={isOfficeInitialized}></AppVisitors>
        </Route>
        <Route exact path="/roomBookings">
          <AppRoomBookings isOfficeInitialized={isOfficeInitialized} />
        </Route>
        <Route exact path="/selectLocation/:idLocationParam?">
          <SelectLocation />
        </Route>
      </Switch>
      {loadAppropriateApp()}
    </>
  );
};

export default App;
